var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all"},[_c('el-image',{staticClass:"all-image",attrs:{"fit":"contain","src":require('@/assets/image/404.gif')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }